import { ApartmentTypeService } from './../../api/apartment-type.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ViewChild, ElementRef, OnDestroy, Injector, Inject, Injectable } from '@angular/core';
import { PropertySearch, ApartmentType } from './../../models/index';
import * as Raven from 'raven-js';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponent } from '../base-component';
import { FbqService } from '../../analytics/fbq.service';

@Injectable()
export abstract class AbstractApartmentTypeSearch extends BaseComponent implements OnDestroy {
  static propertySearch: PropertySearch = new PropertySearch();
  @ViewChild('form') form: NgForm;
  @ViewChild('section') section: ElementRef;
  timeoutId: any;
  apartmentTypes: ApartmentType[] = [];
  page: number = 1;
  apiLoading: boolean = false;
  endOfList: boolean = false;
  subscription: Subscription = new Subscription();
  sort: string = '';
  fbqService: FbqService;

  public router: Router;
  public apartmentTypeService: ApartmentTypeService;

  constructor(
    injector: Injector,
    @Inject('WINDOW') public window: any
  ) {
    super(injector);
    this.router = injector.get(Router);
    this.fbqService = injector.get(FbqService);
    this.apartmentTypeService = injector.get(ApartmentTypeService);
  }

  getPropertySearch(): PropertySearch {
    return AbstractApartmentTypeSearch.propertySearch;
  }

  notifyFb(): void {
    let contentName = 'ApartmentTypeSearch';

    if (AbstractApartmentTypeSearch.propertySearch.room_count)
      contentName += '_' + AbstractApartmentTypeSearch.propertySearch.room_count + 'rooms';

    this.fbqService.sendEvent(
      'ViewContent',
      {
        content_name: contentName
      }
    );
  }

  refreshApartmentTypes(): Promise<ApartmentType[] | void> {
    this.page = 1;
    this.apartmentTypes = [];
    this.apiLoading = false;
    this.endOfList = false;

    this.notifyFb();

    Raven.captureBreadcrumb({
      message: 'refreshApartmentTypes',
      category: 'apartmentTypes infinite scroll'
    });

    return this.addApartmentType();
  }

  addApartmentType(): Promise<ApartmentType[] | void> {
    if (this.apiLoading) {
      return;
    }

    this.apiLoading = true;
    const currentPage = this.page++;
    Raven.captureBreadcrumb({
      message: 'addApartmentType, page: ' + currentPage,
      category: 'apartmentTypes infinite scroll'
    });

    this.apartmentTypeService.getApartmentTypes(AbstractApartmentTypeSearch.propertySearch, this.sort, currentPage).then(apartmentTypes => {
      this.apiLoading = false;

      Raven.captureBreadcrumb({
        message: 'addApartmentType API resonse, page: ' + currentPage,
        category: 'apartmentTypes infinite scroll'
      });

      if (currentPage === 1) {
        if (this.apartmentTypes.length) {
          Raven.captureMessage(
            'ApartmentType list error: possbile duplication detected',
            { level: 'warning' }
          );
        }
        this.apartmentTypes = apartmentTypes;
      } else {
        this.apartmentTypes = this.apartmentTypes.concat(apartmentTypes);
      }

      if (apartmentTypes.length < 15) {
        this.endOfList = true;
        return;
      }
    })
      .catch(() => this.apiLoading = false);
  }

  search(): void {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(
      () => {
        for (const field in AbstractApartmentTypeSearch.propertySearch) {
          if (
            AbstractApartmentTypeSearch.propertySearch[field] === null
            || AbstractApartmentTypeSearch.propertySearch[field] === undefined
          ) {
            delete AbstractApartmentTypeSearch.propertySearch[field];
          }
        }
        if (this.window) {
          this.router.navigate(
            [ this.window.location.pathname ],
            {
              queryParams: AbstractApartmentTypeSearch.propertySearch
            }
          );
        }
      },
      200
    );
  }

  onScroll(): void {
    if (this.window) {
      if (!this.endOfList && this.section.nativeElement.getBoundingClientRect().bottom - this.window.innerHeight < 0) {
        this.addApartmentType();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }

  resetFilters(): void {
    AbstractApartmentTypeSearch.propertySearch = new PropertySearch();
    if (!this.form.touched && !this.form.dirty) {
      this.search();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/abstract-apartment-types-search.model.ts